import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryListController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryListController.php
* @route '/api/contact-directory'
*/
const GetDirectoryListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDirectoryListController.url(options),
    method: 'get',
})

GetDirectoryListController.definition = {
    methods: ["get","head"],
    url: '/api/contact-directory',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryListController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryListController.php
* @route '/api/contact-directory'
*/
GetDirectoryListController.url = (options?: RouteQueryOptions) => {
    return GetDirectoryListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryListController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryListController.php
* @route '/api/contact-directory'
*/
GetDirectoryListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDirectoryListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactDirectory\GetDirectoryListController::__invoke
* @see app/Http/Controllers/ContactDirectory/GetDirectoryListController.php
* @route '/api/contact-directory'
*/
GetDirectoryListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDirectoryListController.url(options),
    method: 'head',
})

export default GetDirectoryListController